import * as XLSX from "xlsx-js-style";
import { formatEnum } from "../utils/enumIslemTurFormat";
import { calculateIslemAnindaBakiyeMap } from "../utils/IslemAnindaBakiyeUtil";

const ziynetShortMap = {
  "Yeni ATA": "YA",
  "Yeni YARIM": "YY",
  "Yeni ÇEYREK": "YÇ",
  "Eski ATA": "EA",
  "Eski YARIM": "EY",
  "Eski ÇEYREK": "EÇ",
};

const formatIslemTurWithZiynet = (r) => {
  const base = formatEnum(r.islemTur);

  if (!r?.islemTur?.startsWith("ZIYNET")) {
    return base;
  }

  const short = ziynetShortMap[r.stokAdi];
  return short ? `${base} (${short})` : base;
};


export const downloadHesapExcel = ({
  allRows,        // ⬅ TÜM işlemler
  filteredRows,   // ⬅ sadece gösterilecek satırlar
  hesapAdi,
  filterStart,
  filterEnd,
}) => {

      const bakiyeMap = calculateIslemAnindaBakiyeMap(allRows);

      const startText = filterStart
        ? new Date(filterStart).toLocaleDateString("tr-TR")
        : "";

      const endText = filterEnd
        ? new Date(filterEnd).toLocaleDateString("tr-TR")
        : "";

      const excelBaslik =
        startText || endText
          ? `${hesapAdi} — ${startText || "..."} – ${endText || "..."} tarihleri arasındaki işlemler`
          : `${hesapAdi} — Tüm zamanlardaki işlemler`;


      const data = filteredRows.map((r) => {
        const rec = bakiyeMap[Number(r.id)];

        return {
          Tarih: new Date(r.tarih).toLocaleString("tr-TR"),
          Tür: formatIslemTurWithZiynet(r),
          Verilen: Number(r.borc ?? 0),
          Alınan: Number(r.alacak ?? 0),
          Birim:
                      r.islemTur === "NAKIT_ISLEM_GRAM_ALINDI" ||
                      r.islemTur === "NAKIT_ISLEM_GRAM_VERILDI"
                        ? "GRAM"
                        : r.birim,
          "Bakiye":
            rec != null && rec.value != null ? Number(rec.value) : 0,
          Açıklama: r.aciklama || "",
        };
      });

      const wb = XLSX.utils.book_new();
      const ws = XLSX.utils.json_to_sheet(data, { origin: "A2" });

      // Kaç kolon var?
      const colCount = Object.keys(data[0] || {}).length;


      // A1 → son kolona kadar merge
      ws["!merges"] = [
        {
          s: { r: 0, c: 0 },
          e: { r: 0, c: colCount - 1 },
        },
      ];

      // Başlık hücresi
      ws["A1"] = {
        t: "s",
        v: excelBaslik,
        s: {
          fill: {
            fgColor: { rgb: "F7E6B5" }, // kolon başlığıyla aynı
          },
          font: {
            bold: true,
            sz: 14,
          },
          alignment: {
            horizontal: "center",
            vertical: "center",
          },
        },
      };

      // Satır yüksekliği (daha ferah dursun)
      ws["!rows"] = [{ hpt: 32 }];


      // Sayı formatı uygula (TR görünüm)
      const range = XLSX.utils.decode_range(ws["!ref"]);

      for (let R = 2; R <= range.e.r; R++) { // 1 = header sonrası
        ["Verilen", "Alınan", "Bakiye"].forEach((colName) => {
          const colIndex = Object.keys(data[0]).indexOf(colName);
          if (colIndex === -1) return;

          const cellAddress = XLSX.utils.encode_cell({ r: R, c: colIndex });
          if (!ws[cellAddress]) return;

          ws[cellAddress].t = "n";              // number
          ws[cellAddress].z = "#,##0.00";       // Excel format
        });
      }

      // Header hücrelerine stil ver
      const rangeStyle = XLSX.utils.decode_range(ws["!ref"]);

      for (let C = rangeStyle.s.c; C <= rangeStyle.e.c; C++) {
        const cellAddress = XLSX.utils.encode_cell({ r: 1, c: C });

        if (!ws[cellAddress]) continue;

        ws[cellAddress].s = {
          fill: {
            fgColor: { rgb: "F7E6B5" }, // altın ton
          },
          font: {
            bold: true,
            color: { rgb: "000000" },
          },
          alignment: {
            horizontal: "center",
            vertical: "center",
          },
          border: {
            top: { style: "thin" },
            bottom: { style: "thin" },
            left: { style: "thin" },
            right: { style: "thin" },
          },
        };
      }

      // DATA hücrelerine arka plan + border ver
      for (let R = 2; R <= rangeStyle.e.r; R++) {
        for (let C = rangeStyle.s.c; C <= rangeStyle.e.c; C++) {
          const cellAddress = XLSX.utils.encode_cell({ r: R, c: C });
          if (!ws[cellAddress]) continue;

          ws[cellAddress].s = {
            ...(ws[cellAddress].s || {}),
            fill: {
              fgColor: { rgb: "FFFDF5" }, // çok açık krem
            },
            border: {
              top: { style: "thin" },
              bottom: { style: "thin" },
              left: { style: "thin" },
              right: { style: "thin" },
            },
            alignment: {
              vertical: "center",
            },
          };
        }
      }

      // Kolon genişliklerini otomatik ayarla (formatlı değere göre)
      const colWidths = Object.keys(data[0] || {}).map((key) => {
        const maxLength = Math.max(
          key.length,
          ...data.map((row) => {
            if (row[key] == null) return 0;

            // Sayısal kolonlar için formatlı uzunluk tahmini
            if (["Verilen", "Alınan"].includes(key)) {
              return Number(row[key]).toLocaleString("tr-TR", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }).length;
            }

            // Diğer kolonlar
            return row[key].toString().length;
          })
        );

        return { wch: maxLength + 3 }; // +3 güvenli boşluk
      });

      ws["!cols"] = colWidths;



      XLSX.utils.book_append_sheet(wb, ws, "HesapIslemleri");
      XLSX.writeFile(wb, "hesap-islemleri.xlsx");
};
